import { type ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { ROUTES } from 'constants/urls'

export const PERMISSION = {
  ADMIN: 'ADMIN',
  ASVEN: 'ASVEN',
  ASVEN_ESP: 'ASVEN_ESP',
  GENAC: 'GENAC',
  VENDE: 'VENDE',
} as const
export type ActionPerm = (typeof ACTIONS_SCREENS)[keyof typeof ACTIONS_SCREENS]
export type ScreenPerm = (typeof SCREENS)[keyof typeof SCREENS]
export interface OptionProps {
  label: string
  route: string
  screen: ScreenPerm
}
interface navItemInterface {
  label: string
  route: string
  item: Array<OptionProps>
  screen: ScreenPerm | ScreenPerm[]
  action?: ActionPerm
}
interface navItemsInterface {
  [index: string]: navItemInterface
}

export const SM_BREAKPOINT_MODIFIER = 70

export const LABEL_PAGE = {
  APPROVAL_RANGES: 'Alçadas de aprovação',
  APROVACOES: 'Aprovações',
  BACKOFFICE: 'Backoffice',
  CREATE_ORDER: 'Pedido',
  EXPORT_ORDER: 'Internacional',
  EXTRA_VOLUME: 'Volume extra',
  FRANCHISES_ORDER: 'Franquias massivo',
  HOME_PAGE: 'Página Inicial',
  INTERNATIONAL_SAMPLE: 'Amostra Internacional',
  KEY_ACCOUNTS: 'Key Accounts',
  LEAD_TIMES: 'Lead Times',
  MANAGE_ORDER: 'Gerenciamento',
  NATIONAL_SAMPLE: 'Amostra Nacional',
  ND: 'Negociação Diferenciada',
  ORDER_DRAFTS: 'Rascunhos de pedidos',
  ORDERS_MADE: 'Pedidos efetivados',
  RECOMMENDATION: 'Recomendação',
  SINGLE_ORDER: 'Nacional',
  STOCK_REPORT: 'Relatório de Estoque',
}

export const navItems: navItemsInterface = {
  aprovacoes: {
    item: [
      {
        label: LABEL_PAGE.ND,
        route: ROUTES.nd.base,
        screen: SCREENS.ND_MANAGE,
      },
      {
        label: LABEL_PAGE.EXTRA_VOLUME,
        route: ROUTES.extra_volume.base,
        screen: SCREENS.EXTRA_VOLUME,
      },
    ],
    label: LABEL_PAGE.APROVACOES,
    route: '',
    screen: [SCREENS.ND_MANAGE, SCREENS.EXTRA_VOLUME],
  },
  backoffice: {
    item: [
      {
        label: LABEL_PAGE.APPROVAL_RANGES,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.ranges.base}`,
        screen: SCREENS.BACKOFFICE_RANGE,
      },
      {
        label: LABEL_PAGE.LEAD_TIMES,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.lead_times.base}`,
        screen: SCREENS.TECHNICAL_CONSULTATION,
      },
      {
        label: LABEL_PAGE.KEY_ACCOUNTS,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.key_accounts.base}`,
        screen: SCREENS.TECHNICAL_CONSULTATION,
      },
    ],
    label: LABEL_PAGE.BACKOFFICE,
    route: '',
    screen: [SCREENS.BACKOFFICE_RANGE, SCREENS.TECHNICAL_CONSULTATION],
  },
  createOrder: {
    item: [
      {
        label: LABEL_PAGE.SINGLE_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.new.base}`,
        screen: SCREENS.ORDER,
      },
      {
        label: LABEL_PAGE.EXPORT_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.international.base}`,
        screen: SCREENS.INTERNATIONAL_EDI,
      },
      {
        label: LABEL_PAGE.FRANCHISES_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.franchises.base}`,
        screen: SCREENS.FRANCHISES_BATCH,
      },
      {
        label: LABEL_PAGE.NATIONAL_SAMPLE,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.nationalSampleOrder.base}`,
        screen: SCREENS.NATIONAL_SAMPLE,
      },
      {
        label: LABEL_PAGE.INTERNATIONAL_SAMPLE,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.internationalSampleOrder.base}`,
        screen: SCREENS.INTERNATIONAL_SAMPLE,
      },
      {
        label: LABEL_PAGE.RECOMMENDATION,
        route: '',
        screen: SCREENS.RECOMMENDATION,
      },
    ],
    label: LABEL_PAGE.CREATE_ORDER,
    route: '',
    screen: [SCREENS.ORDER, SCREENS.INTERNATIONAL_EDI],
  },
  initialPage: {
    item: [],
    label: LABEL_PAGE.HOME_PAGE,
    route: ROUTES.app.base,
    screen: SCREENS.HOME,
  },
  manageOrder: {
    item: [],
    label: LABEL_PAGE.MANAGE_ORDER,
    route: ROUTES.manage.base,
    screen: SCREENS.MANAGE,
  },
  stockReport: {
    item: [],
    label: LABEL_PAGE.STOCK_REPORT,
    route: ROUTES.stock_report.base,
    screen: SCREENS.HOME,
  },
}

// TODO: Move to environment variables
export const PHONE_NUMBER = '(11) 3847-7477'
export const SUPPORT_LINK =
  'https://prodalpargatas.service-now.com/sp?id=sc_cat_item&sys_id=1e3631141bf634104b91da8fe54bcbd6&sysparm_category=f876b1141bf634104b91da8fe54bcbe4'
export const SUPPORT_EMAIL = 'suporte.vendas@alpargatas.com'

export const voidFunction = () => {
  return
}
